import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../stores/store";
import { useEffect } from "react";
import { fetchCoupons } from "../../stores/slices/couponSlice";


const Coupon = () => {
  const couponData = useSelector((state: RootState) => state.coupons.coupons);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchCoupons());
  }, [dispatch]);

  const toEdit = (id: number) => {
    navigate(`/coupon/edit/${id}`);
  }

  return (
    <>
      <h2>クーポン一覧</h2>
      <div className="submit big">
        <Link to={"/coupon/new"}>新規登録</Link>
      </div>

      <div className="tableDataList">
        <table>
          <tbody>
            <tr>
              <th>クーポンID</th>
              <th>クーポン名</th>
              <th>通常定価</th>
              <th>クーポン価格</th>
              <th>コード</th>
              <th>使用回数制限</th>
              <th>利用制限</th>
              <th>クーポン公開日</th>
              <th>クーポン終了日</th>
              <th>登録日</th>
              <th>更新日</th>
              <th style={{minWidth: '80px'}}>ステータス</th>
            </tr>

            {couponData.map((coupon : any) => (
              <tr onClick={() => toEdit(coupon.id)} style={{ cursor: 'pointer'}} key={coupon.id}>
                <td>
                  {coupon.id}
                </td>
                <td>
                  {coupon.name}
                </td>
                <td>
                  {coupon.teika}
                </td>
                <td>
                  {coupon.baika}
                </td>
                <td>
                  {coupon.code}
                </td>
                <td>
                  {coupon.usagelimit}
                </td>
                <td>
                  {coupon.special}
                </td>
                <td>
                  {coupon.starttime}
                </td>
                <td>
                  {coupon.endtime}
                </td>
                <td>
                  {coupon.created_at}
                </td>
                <td>
                  {coupon.updated_at}
                </td>
                <td>
                  {coupon.status === 0 ? ( 
                    <span>公開</span>
                  ):(
                    <span>非公開</span>
                  )}
                </td>
                <td>
                  <div className="submit">
                    <Link to={`/coupon/edit/${coupon.id}`}>登録</Link>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
export default Coupon;